import React from 'react';

import { CmBox, CmCard } from '@/components/uiParts';

export const MenuManagementCardWrapper: React.FC = ({
  children,
}): JSX.Element => {
  return (
    <CmBox padding="0 0 20px">
      <CmCard padding="20px 40px 60px">{children}</CmCard>
    </CmBox>
  );
};
